module.exports = __webpack_public_path__ + "img/form_bg.8f68c204.png";